<template>
    <!-- Added by Mapbox -->
</template>

<script>
    import Group from './_group';
    export default {
        name: "group",
        props: {
            map: Object, // Passed by parent mapbox.vue component
            name: String, // Name of the Group
            type: String, // Type of Group
            propertyKey: { // Marker property used for grouping
                type: String,
                default: 'type',
            },
            clustering: { // Turn clustering on?
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                group: new Group(this.name, this.type, this.clustering, this.propertyKey)
            };
        },
        mounted() {
            // On component mount, register a new group name
            this.map.addMarkerGroup(this.group);
        }
    };
</script>


// WEBPACK FOOTER //
// Assets/Scripts/Components/Mapbox/group/group.vue